import Vue from 'vue';
import Vuex from 'vuex';
import CommonModule from '@questelservices/common';
import UserSettingsModule from './store/UserSettingsModule'
import MatterWorkModule from './store/MatterWorkModule'

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    CommonModule,
    UserSettingsModule,
    MatterWorkModule
  },
  state: {
    environment: process.env.NODE_ENV
  }
});

export default store;
